export enum filterQueryParm {
    //Client searh Filter
    Client_Name = 'Name',
    Client = 'Client',
    AccountManager = 'Account Manager',
    JobManager = 'Job Manager',
    Phone = 'Phone',
    Mobile = 'Mobile',
    Email = 'Email',
    Client_Contact_Name = 'Contact Name',

    //Suplier search Filter
    SupplierName = 'Supplier Name',
    Supplier_Name = 'Name',
    Address = 'Address',
    SupplierPhone = 'Phone',
    SupplierMobile = 'Mobile',
    Fax = 'Fax',
    Supplier_Contact_Name = 'Contact Name',


    //Task Search Filter
    TaskName = 'Task Name',
    BaseRate = 'Base Rate',
    BillableRate = 'Billable Rate',

    //Costs Search Filter
    CostsName = 'Name',
    CostsDescription = 'Description',
    Supplier = 'Supplier',
    Code = 'Code',
    BaseCost = 'Base Cost',

    //job catergory
    JobCatergoryName = 'Category Name',
    JobCatergoryDescription = 'Description',

    //job state
    JobState = 'state',
    JobStateType = 'state Type',

    //staff
    StaffName = 'Name',
    StaffRole = 'Role',
    StaffPhone = 'Phone',
    StaffMobile = 'Mobile',
    StaffEmail = 'Email',

    //Client Search Filter
    ClientName = 'Name',
    ClientPaymentTerm = 'Payment Term',
    ClientMarkup = 'Markup',

    //team state
    TeamName = 'Name',
    TeamStaff = 'staff',

    //GroupTask state
    GroupTaskName = 'Group Task Name',

    //collaboration jobs
    JobsName = 'Name',
    Jobsclient = 'client',
    Jobsstate = 'state',
    JobsStartDate = 'Start Date',
    JobsEndDate = 'End Date',
    JobsNo = 'No',

    //business quotes
    QuotesName = 'Name',
    QuotesclientName = 'client',
    QuotesOwner = 'Owner',
    QuotesStartDate = 'Start Date',
    QuotesEndDate = 'End Date',
    Quotesstate = 'state',
    QuotesAmount = 'Amount',
    QuotesNo = 'No',

    //Business Invoice
    InvoiceNo = 'No',
    InvoiceName = 'Name',
    InvoiceBillingType = 'Billing Type',
    InvoiceClient = 'Client',
    InvocieJob = 'Job',
    InvoiceState = 'State',
    InvoiceDate = 'Invoice Date',
    InvoiceDueDate = 'Due Date',
    InvoiceAmount = 'Amount',
    InvoiceDueAmount = 'Due Amount',
}

export enum SearchQueryParm {
    //Interaction searh Filter
    Name = 'name',
    contactName = 'client',
    account_Manager = 'account_manager',
    jobManager = 'job_manager',
    phone = 'phone',
    mobile = 'mobile',
    email = 'email',    
    Address = 'address',    
    Fax = 'fax',   
    client_contact_name = 'client',
    supplier_contact_name = 'supplier',


    //Business Invoice search Filter
    InvoiceNo = 'No',
    InvoiceName = 'Name',
    InvoiceBillingType = 'Billing Type',
    InvoiceClient = 'Client',
    InvocieJob = 'Job',
    InvoiceState = 'State',
    InvoiceDate = 'Invoice Date',
    InvoiceDueDate = 'Due Date',
    InvoiceAmount = 'Amount',
    InvoiceDueAmount = 'Due Amount',

    //collaboration jobs
    jobsName = 'name',
    jobsclient = 'client',
    jobsstate = 'state',
    jobsStartDate = 'start_date',
    jobsEndDate = 'end_date',
    jobsNo = 'number',
    
    //Businees Job
    QuotesName = 'name',
    QuotesclientName = 'client',
    QuotesOwner = 'quotes_owner',
    QuotesStartDate = 'start_date',
    QuotesEndDate = 'end_date',
    Quotesstate = 'state',
    QuotesNo = 'number',
    QuotesAmount ='amount',

    //organization cost search filter
    Costs_Name = 'name',
    Costs_Description = 'description',
    supplier = 'supplier_name',
    code = 'code',
    Unit_Cost = 'unit_cost',
  
    //organization task search filter
    TaskName = 'name',
    BaseRate = 'base_rate',
    BillableRate = 'billable_rate',
    
    //organization task search filter
     GroupTaskName = 'name',

    //job catergory
    JobCatergoryName = 'name',
    JobCatergoryDescription = 'description',

    //job state
    JobState = 'name',
    JobStateType = 'job_states_type_name',
 
    //client type
    ClientName = 'name',
    ClientPaymentTerm = 'payment_terms_name',
    ClientMarkup = 'markup',
}